export function checkNewTabButtonTarget() {
  if (window.__mlatNewTabChecked) return;
  window.__mlatNewTabChecked = true;
  var $btn = document.querySelectorAll('a');
  var _newTabUrls = (window.mlatConfig && window.mlatConfig.newTabUrls)
    || ['my.jurnal.id/', 'help-center.jurnal.id', 'mekari.com'];
  var currentHost = window.location.hostname;
  if ($btn.length > 0) {
    for(var i = 0; i < $btn.length; i++) {
      var $t = $btn[i],
          $href = $t.getAttribute('href');
      if($href) {
        // Never force-open the site's own links in a new tab, even if the href
        // text happens to contain a configured pattern — e.g. this site running
        // on officeless.mekari.com contains the substring "mekari.com", which is
        // a valid external pattern for OTHER Mekari properties but must not
        // match this site's own internal links.
        var isSameHost;
        try {
          isSameHost = new URL($href, window.location.href).hostname === currentHost;
        } catch (e) {
          isSameHost = true; // non-URL hrefs (mailto:, tel:, javascript:, #anchor) — treat as same-site
        }
        if (!isSameHost && _newTabUrls.some(function(u) { return $href.includes(u); })) {
          $t.setAttribute('target','_blank');
        }
      }
    }
  }
}
